import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  games: [],
  wallet: 0,
  currentDrawInfo: null,
  winLoseRecord: {},
};

const gameInfoPanaSlice = createSlice({
  name: "gameInfoPanaSlice",
  initialState,
  reducers: {
    // from VIEW_GAME_INFO (play_matka): { games, total_wallet, current_draw_info }
    SET_PANA_GAME_INFO: (state, action) => {
      const d = action.payload || {};
      state.games = d.games || [];
      if (d.total_wallet !== undefined && d.total_wallet !== null) state.wallet = d.total_wallet;
      state.currentDrawInfo = d.current_draw_info || null;
    },
    // from UPDATED_WALLET: chips
    SET_PANA_WALLET: (state, action) => {
      state.wallet = action.payload ?? 0;
    },
    // claim result (shown in WinnerPopup)
    SET_PANA_WIN_LOSE_RECORD: (state, action) => {
      state.winLoseRecord = action.payload || {};
    },
    CLEAR_PANA_WIN_LOSE_RECORD: (state) => {
      state.winLoseRecord = {};
    },
  },
});

export const { SET_PANA_GAME_INFO, SET_PANA_WALLET, SET_PANA_WIN_LOSE_RECORD, CLEAR_PANA_WIN_LOSE_RECORD } = gameInfoPanaSlice.actions;

export const selectPanaGames = ({ gameInfoPanaSlice }) => gameInfoPanaSlice.games;
export const selectPanaWallet = ({ gameInfoPanaSlice }) => gameInfoPanaSlice.wallet;
export const selectPanaCurrentDrawInfo = ({ gameInfoPanaSlice }) => gameInfoPanaSlice.currentDrawInfo;
export const selectPanaWinLoseRecord = ({ gameInfoPanaSlice }) => gameInfoPanaSlice.winLoseRecord;

export default gameInfoPanaSlice.reducer;
